<template>
  <el-dialog :visible="show" @close="closeModal">
    <ModalHeader slot="title" icon="fas fa-file-download" title="Tải báo cáo" />
    <el-row :gutter="20">
      <el-col :span="8">
        <div @click="handleDownloadSpellReport(document.slug)">
          <el-card :body-style="{ padding: '0px' }">
            <img src="@/assets/img/full_report.jpg" class="image padding-left-15 padding-right-15" />
            <div class="report_download_button">
              <el-button type="warning" round>Tải báo cáo chính tả </el-button>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :span="8">
        <div @click="handleDownloadSummaryReport(document.slug)">
          <el-card :body-style="{ padding: '0px' }">
            <img src="@/assets/img/summary_report.jpg" class="image padding-left-15 padding-right-15" />
            <div class="report_download_button">
              <el-button type="primary" round>Tải báo cáo tóm tắt </el-button>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :span="8">
        <div @click="handleDownloadFullReport(document.slug)">
          <el-card :body-style="{ padding: '0px' }">
            <img src="@/assets/img/full_report.jpg" class="image padding-left-15 padding-right-15" />
            <div class="report_download_button">
              <el-button type="success" round>Tải báo cáo chi tiết </el-button>
            </div>
          </el-card>
        </div>
      </el-col>

    </el-row>
    <span slot="footer">
      <el-button @click="closeModal">Hủy bỏ </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { apiDownloadDocumentAsArrayBuffer } from "@/services/document_management_service"
import { pushArraybuffer2Client } from "@/helpers/DownloadHelper"
import { DocumentState, DownloadType } from "@/constants/DoITConstant"
import FAIcon from "@/components/common/FAIcon.vue"
import ModalHeader from '@/components/common/ModalHeader.vue'

export default {
  name: "DocumentReportModal",
  components: {ModalHeader, FAIcon },
  data: function () {
    return {
      show: false,
      document: {},
    }
  },
  methods: {
    showModal(document) {
      this.document = document
      this.show = true
    },
    closeModal() {
      this.show = false
    },
    async handleDownloadSummaryReport(slug) {
      console.log("Downloaded Summary Report" + slug)
      const loading = this.$loading({
        lock: true,
        text: "Đang tải tài liệu",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "l-spinner",
      })
      let res = await apiDownloadDocumentAsArrayBuffer(slug, DownloadType.GENERAL_REPORT)
      // console.log(res)
      pushArraybuffer2Client(res, "summary_" + slug + ".pdf")

      loading.close()

      if (res == null) {
        this.$message.error("Có lỗi xảy ra")
      } else {
        this.$emit("success")
      }
    },
    async handleDownloadSpellReport(slug) {
      const loading = this.$loading({
        lock: true,
        text: "Đang tải tài liệu",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "l-spinner",
      })
      let res = await apiDownloadDocumentAsArrayBuffer(slug, DownloadType.SPELL_REPORT)
      pushArraybuffer2Client(res, "full_" + slug + ".pdf")
      loading.close()

      if (res == null) {
        this.$message.error("Có lỗi xảy ra")
      } else {
        this.$emit("success")
      }
    },
    async handleDownloadFullReport(slug) {
      console.log("Downloaded Full Report" + slug)

      const loading = this.$loading({
        lock: true,
        text: "Đang tải tài liệu",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "l-spinner",
      })
      let res = await apiDownloadDocumentAsArrayBuffer(slug, DownloadType.HIGHLIGHT_REPORT)
      pushArraybuffer2Client(res, "full_" + slug + ".pdf")
      loading.close()

      if (res == null) {
        this.$message.error("Có lỗi xảy ra")
      } else {
        this.$emit("success")
      }
    },
  },
}
</script>

<style scoped>
.report_download_button {
  padding: 14px;
  text-align: center;
}

.el-form-item__content .checker-type-container .el-input-group {
  margin: 0 0 8px 0;
  color: #8d9094;
  width: calc(100% - 180px - 10px);
  min-width: 260px;
}

.el-form-item__content .el-input-group {
  margin-top: 10px;
}

.image {
  width: 100%;
  display: block;
  filter: grayscale(50%);
  -webkit-filter: grayscale(50%);
  -webkit-transition: all 0.5s ease;
}

.image:hover {
  filter: grayscale(10%);
  filter: "gray";
  -webkit-filter: grayscale(10%);
  filter: none;
  transition: 0.5s ease;
}
</style>
